import React from 'react';

import { useHistory } from 'react-router-dom';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';

import { isMobile } from '../../../../../utils/mobile';

const FillProfileDialog = ({ open }) => {
  const history = useHistory();

  const redirectToProfile = () => {
    history.push('/profile');
  };

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': {
        minWidth: '360px',
      },
      '& .MuiDialog-container': {
        height: 'auto',
        marginTop: isMobile ? '55px' : '150px',
      } }}
      fullScreen={isMobile}
      open={open}
    >
      <DialogTitle>
        <Grid container direction='row'>
          <Grid item>
            Falta completar perfil
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent dividers>
        <Typography>
          <b>Complete</b>
          {' '}
          os campos obrigatórios do
          {' '}
          <b>perfil do usuário</b>
          {' '}
          para marcação.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          sx={{ color: '#6B48FE' }}
          onClick={() => {
            redirectToProfile();
          }}
        >
          Completar perfil
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FillProfileDialog;
